module.exports = __webpack_public_path__ + "static/img/under_construction.cf8a294.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/under_construction.svg
// module id = Mn2T
// module chunks = 1